/* eslint-disable no-underscore-dangle */
// vendors
import React from 'react';
import PropTypes from 'prop-types';

import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import { Container, StyledPicture, Caption } from './Figure.styles';

const sanityConfig = { projectId: '43rghw2e', dataset: 'production' };

const Figure = ({ node, fluidConfig, sizes, ...rest }) => {
  if (node._type !== 'figure') return null;

  let source = {};

  if (node.asset._type === 'sanity.imageAsset') {
    source = getFluidGatsbyImage(node.asset.id, fluidConfig, sanityConfig);
  }

  return (
    <Container {...rest}>
      <StyledPicture
        fluid={source}
        alt={node.alt}
        style={{ overflow: 'visible !important' }}
      />

      {node.caption && <Caption>{node.caption}</Caption>}
    </Container>
  );
};

Figure.propTypes = {
  sizes: PropTypes.string,
  fluidConfig: PropTypes.shape({
    maxWidth: PropTypes.string,
    maxHeight: PropTypes.string,
    sizes: PropTypes.string,
  }),
  node: PropTypes.shape({
    _type: PropTypes.string.isRequired,
    caption: PropTypes.string,
    alt: PropTypes.string.isRequired,
    asset: PropTypes.shape({
      _type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

Figure.defaultProps = {
  sizes: undefined,
  fluidConfig: {},
};

export default Figure;
